export default {"src":"/_next/static/media/champion.aea07355.svg","height":184,"width":184};